// 客服帮用户创建回收订单PC页
import native from '@zz-common/native-adapter'
export default {
  path: '/gold-recycle',
  name: 'gold-recycle',
  meta: {
    title: '转转回收',
    pageId: 'A2633', // 将作为页面埋点的 actionType
    level: 5
  },
  // 进入路由前直接重定向到线下门店用户侧H5页面，并携带所有query参数
  beforeEnter: (to, from, next) => {
    const baseUrl = 'https://m.zhuanzhuan.com/u/offline_store_user/index.html#/gold-recycle'
    const query = to.query || {}
    const queryPairs = []
    if (query.__t === '74') {
      next()
    }
    Object.keys(query).forEach((key) => {
      const value = query[key]
      // 处理数组类型的query参数（如：?id=1&id=2）
      if (Array.isArray(value)) {
        value.forEach((item) => {
          queryPairs.push(`${encodeURIComponent(key)}=${encodeURIComponent(item)}`)
        })
      } else if (value != null && value !== '') {
        // 过滤空值
        queryPairs.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
      }
    })

    const queryString = queryPairs.join('&')
    const redirectUrl = queryString ? `${baseUrl}?${queryString}` : baseUrl
    // 使用 replace 替换当前历史记录，返回时不会回到这个中间页面
    native.skipToUrl({
      targetUrl: redirectUrl,
      needClose: 1
    })
  },
  component: () =>
    import(/* webpackChunkName: "gold-recycle" */ 'app/gold-recycle/index.vue')
}
